import React, { useState } from 'react';
import styled from 'styled-components';
//@ts-ignore
import logo from '../../assets/logo-samdoc.png';
import { useAuth } from '../../Contexts/AuthContext';
import { useNavigate } from 'react-router-dom';
import ApiService from '../../Config/ApiConfig';
import { LoginDto } from '../../Dtos/LoginDto';
import axios from 'axios';
import LoadingPage from '../../Components/Loading/Loading';
import { ICredencialDto } from '../../Dtos/CredencialDto';

interface LoginFormData {
  usuario: string;
  senha: string;
}

const LoginPage: React.FC = () => {
  const { login } = useAuth()
  const [loading, setLoading] = useState<boolean>(false)
  const [mensagem, setMensagem] = useState<string>()
  const [formData, setFormData] = useState<LoginFormData>({
    usuario: '',
    senha: ''
  });

  const navigate = useNavigate()


  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleSubmit = async (e: React.FormEvent) => {
    try {
      e.preventDefault();
      setLoading(true)

      const apiService = new ApiService();

      const loginDto = await apiService.post<LoginDto>("/auth/login", { login: formData.usuario, password: formData.senha })

      localStorage.setItem("token", loginDto.token)
      localStorage.setItem("nome", loginDto.nome)

      const credencialDto = await apiService.get<ICredencialDto>("/auth/carregarCredencialPeloIdUsuario", { params: { sd01login: loginDto.nome} })
      
      localStorage.setItem("credencial", JSON.stringify(credencialDto))

      login()
      navigate("/home")
    } catch (error) {
      if (axios.isAxiosError(error)) {
        setMensagem(error.response?.data)
      }
    } finally {
      setLoading(false)
    }
  };

  if (loading) {
    return (
      <LoadingPage />
    )
  }
  return (
    <Container>
      <LoginCard>
        <Logo src={logo} alt="SAMDOC - Gerenciador de Documentos" />
        <Form onSubmit={handleSubmit}>
          <Input
            type="text"
            name="usuario"
            placeholder="Usuário"
            value={formData.usuario}
            onChange={handleChange}
            required
            disabled={loading}
          />
          <Input
            type="password"
            name="senha"
            placeholder="Senha"
            value={formData.senha}
            onChange={handleChange}
            required
            disabled={loading}
          />
          <LoginButton type="submit" disabled={loading}>{
            !loading ? "Login" : "Carregando..."
          }</LoginButton>
        </Form>
        <ForgotPassword href="#">Esqueceu a Senha?</ForgotPassword>
        <Mensagem>{mensagem ?? ""}</Mensagem>
        <Copyright>
          Copyright © 2016-2024 Multitec.
        </Copyright>
      </LoginCard>
    </Container>
  );
}

const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 100vh;
  background-color: ${props => props.theme.cores.fundo.input.principal};
`;

const LoginCard = styled.div`
  background-color: ${props => props.theme.cores.fundo.container.secundario};
  padding: 2rem;
  border-radius: 4px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
  width: 100%;
  max-width: 400px;
`;

const Logo = styled.img`
  display: block;
  margin: 0 auto 2rem;
  max-width: 200px;
`;

const Form = styled.form`
  display: flex;
  flex-direction: column;
  gap: 1rem;
`;

const Input = styled.input`
  padding: 0.75rem;
  border: 1px solid #ddd;
  border-radius: 4px;
  font-size: 1rem;
  width: 100%;
  box-sizing: border-box;
  
  &:focus {
    outline: none;
    border-color: #4D4D3D;
  }
`;

const LoginButton = styled.button`
  background-color: ${(props) => props.theme.cores.primaria};
  color: white;
  padding: 0.75rem;
  border: none;
  border-radius: 4px;
  font-size: 1rem;
  cursor: pointer;
  transition: background-color 0.2s;

  &:hover {
    background-color: #c41826;
  }
`;

const ForgotPassword = styled.a`
  color: ${(props) => props.theme.cores.secundaria};
  text-decoration: none;
  text-align: center;
  font-size: 0.9rem;
  margin-top: 1rem;
  
  &:hover {
    text-decoration: underline;
  }
`;

const Mensagem = styled.p`
  color: ${(props) => props.theme.cores.erro};
  text-align: center;
`

const Copyright = styled.div`
  text-align: center;
  color: ${(props) => props.theme.cores.ofuscado};
  font-size: 0.8rem;
  margin-top: 2rem;
`;

export default LoginPage;